module.exports = __webpack_public_path__ + "img/featured.77f2c090.jpg";